import { FC } from 'react';

import { Backdrop } from '@mui/material';
import { useLayoutState } from 'components/layout/layout';
import Sidebar from './sidebar';

const SidebarOverlay: FC<{}> = () => {
  const { sidebarOpen } = useLayoutState();
  const isOverview = location.pathname.split('/')[1] === 'overview';
  const isDeliveryBoard = location.pathname.split('/')[1] === 'delivery-board';

  return isOverview || isDeliveryBoard ? (
    <Backdrop open={sidebarOpen} sx={{ zIndex: 250 }}>
      <Sidebar hide={!sidebarOpen ? true : false} />
    </Backdrop>
  ) : (
    <Sidebar hide={(isOverview || isDeliveryBoard) && sidebarOpen ? true : false} />
  );
};

export default SidebarOverlay;
